import { Pipe, PipeTransform } from "@angular/core";
import {
  buildCompanyUserAuditLookups,
  resolveAuditDisplayName,
} from "../helpers/company-user-display.util";
import { ApplicationContextService } from "../services/application-context.service";

@Pipe({
  name: "auditDisplayName",
  standalone: true,
})
export class AuditDisplayNamePipe implements PipeTransform {
  constructor(
    private readonly applicationContextService: ApplicationContextService
  ) {}

  transform(token: unknown, fallback = "—"): string {
    const ctx = this.applicationContextService.contextSnapshot;
    const lookups = buildCompanyUserAuditLookups(ctx);
    return resolveAuditDisplayName(String(token ?? ""), lookups, fallback);
  }
}
